import { useState, useEffect } from "react";
import styles from "./feature.module.css";
import { Accordion } from "react-bootstrap";

const FeatureAccess = ({ data, accessState, setAccessState, isEditMode }) => {
  const [openSource, setOpenSource] = useState(null);
  const actions = ["Read", "Write", "Modify"];

  const toggleParentAction = (source, parentFeature, action) => {
    if (
      !accessState?.[source]?.[parentFeature]?.actions ||
      !accessState?.[source]?.[parentFeature]?.children
    ) {
      return;
    }
    setAccessState((prevState) => {
      const newState = { ...prevState };
      const parent = newState[source][parentFeature];
      const newValue = !parent.actions[action];
      if ((action === "write" || action === "modify") && newValue) {
        parent.actions["read"] = true;
      }
      parent.actions[action] = newValue;
      Object.keys(parent.children).forEach((childKey) => {
        if (parent.children[childKey]) {
          if ((action === "write" || action === "modify") && newValue) {
            parent.children[childKey]["read"] = true;
          }
          parent.children[childKey][action] = newValue;
        }
      });
      return newState;
    });
  };

  const toggleChildAction = (source, parentFeature, subFeature, action) => {
    if (!accessState?.[source]?.[parentFeature]?.children?.[subFeature]) {
      return;
    }

    setAccessState((prevState) => {
      const newState = { ...prevState };
      const child = newState[source][parentFeature].children[subFeature];
      child[action] = !child[action];
      if ((action === "write" || action === "modify") && child[action]) {
        child["read"] = true;
      }
      const allChildren = Object.values(
        newState[source][parentFeature].children
      );
      const allChecked = allChildren.every((c) => c[action]);
      if (allChecked) {
        newState[source][parentFeature].actions[action] = true;
        if (action === "write" || action === "modify") {
          newState[source][parentFeature].actions["read"] = true;
        }
      }
      return newState;
    });
  };

  return (
    <div className={styles.roleMatrixContainer}>
      <Accordion
        className={styles.accordionContainer}
        activeKey={openSource}
        onSelect={setOpenSource}
      >
        {data &&
          data.map(({ source, featureList }, idx) => (
            <Accordion.Item
              eventKey={String(idx)}
              className={styles.accordionItem}
              key={source}
            >
              <Accordion.Header className={styles.accordionHeader}>
                <span className={styles.sourceTitle}>{source}</span>
              </Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                {featureList &&
                  featureList.map((feature) => {
                    const parent = accessState[source]?.[feature.parentFeature];
                    const children = feature.subFeatures;
                    return (
                      <div
                        className={styles.parentFeatureCard}
                        key={feature.parentFeature}
                      >
                        <div className={styles.parentHeaderRow}>
                          <span className={styles.parentHeaderFeature}>
                            Parent Feature Name
                          </span>
                          <span className={styles.parentHeaderActions}>
                            {actions.map((action) => (
                              <span
                                className={styles.actionHeader}
                                key={action}
                              >
                                {action}
                              </span>
                            ))}
                          </span>
                        </div>
                        <div className={styles.parentRow}>
                          <span className={styles.parentTitle}>
                            {feature.parentFeature}
                          </span>
                          {actions.map((action) => (
                            <input
                            key={action}
                            type="checkbox"
                            className={styles.checkbox}
                            checked={parent?.actions?.[action.toLowerCase()] || false}
                            onChange={() =>
                              toggleParentAction(
                                source,
                                feature.parentFeature,
                                action.toLowerCase()
                              )
                            }
                            disabled={
                              action === "Read" &&
                              (parent?.actions?.write || parent?.actions?.modify)
                            }
                          />
                          ))}
                        </div>
                        {children?.length > 0 && (
                          <>
                            <div className={styles.childHeaderRow}>
                              <span className={styles.childHeaderFeature}>
                                Feature Name
                              </span>
                              <span className={styles.childHeaderActions}>
                                {actions.map((action) => (
                                  <span
                                    className={styles.actionHeader}
                                    key={action}
                                  >
                                    {action}
                                  </span>
                                ))}
                              </span>
                            </div>
                            <div className={styles.subFeatureList}>
                              {children.map((sub) => (
                                <div
                                  className={styles.subFeatureRow}
                                  key={sub.dashboardFeatureId}
                                >
                                  <span className={styles.subFeatureName}>
                                    {sub.componentName}
                                  </span>
                                  {actions.map((action) => (
                                   <input
                                    key={action}
                                    type="checkbox"
                                    className={styles.checkbox}
                                    checked={
                                      parent?.children?.[sub.componentName]?.[action.toLowerCase()] || false
                                    }
                                    onChange={() =>
                                      toggleChildAction(
                                        source,
                                        feature.parentFeature,
                                        sub.componentName,
                                        action.toLowerCase()
                                      )
                                    }
                                    disabled={
                                      action === "Read" &&
                                      (parent?.children?.[sub.componentName]?.write ||
                                      parent?.children?.[sub.componentName]?.modify)
                                    }
                                  />
                                  ))}
                                </div>
                              ))}
                            </div>
                          </>
                        )}
                      </div>
                    );
                  })}
              </Accordion.Body>
            </Accordion.Item>
          ))}
      </Accordion>
    </div>
  );
};

export default FeatureAccess;
